{
  "activity": 61696,
  "airplay": 61697,
  "alert-circle": 61698,
  "alert-octagon": 61699,
  "alert-triangle": 61700,
  "align-center": 61701,
  "align-justify": 61702,
  "align-left": 61703,
  "align-right": 61704,
  "anchor": 61705,
  "aperture": 61706,
  "archive": 61707,
  "arrow-down": 61708,
  "arrow-down-circle": 61709,
  "arrow-down-left": 61710,
  "arrow-down-right": 61711,
  "arrow-left": 61712,
  "arrow-left-circle": 61713,
  "arrow-right": 61714,
  "arrow-right-circle": 61715,
  "arrow-up": 61716,
  "arrow-up-circle": 61717,
  "arrow-up-left": 61718,
  "arrow-up-right": 61719,
  "at-sign": 61720,
  "award": 61721,
  "bar-chart": 61722,
  "bar-chart-2": 61723,
  "battery": 61724,
  "battery-charging": 61725,
  "bell": 61726,
  "bell-off": 61727,
  "bluetooth": 61728,
  "bold": 61729,
  "book": 61730,
  "book-open": 61731,
  "bookmark": 61732,
  "box": 61733,
  "briefcase": 61734,
  "calendar": 61735,
  "camera": 61736,
  "camera-off": 61737,
  "cast": 61738,
  "check": 61739,
  "check-circle": 61740,
  "check-square": 61741,
  "chevron-down": 61742,
  "chevron-left": 61743,
  "chevron-right": 61744,
  "chevron-up": 61745,
  "chevrons-down": 61746,
  "chevrons-left": 61747,
  "chevrons-right": 61748,
  "chevrons-up": 61749,
  "chrome": 61750,
  "circle": 61751,
  "clipboard": 61752,
  "clock": 61753,
  "cloud": 61754,
  "cloud-drizzle": 61755,
  "cloud-lightning": 61756,
  "cloud-off": 61757,
  "cloud-rain": 61758,
  "cloud-snow": 61759,
  "code": 61760,
  "codepen": 61761,
  "codesandbox": 61762,
  "coffee": 61763,
  "columns": 61764,
  "command": 61765,
  "compass": 61766,
  "copy": 61767,
  "corner-down-left": 61768,
  "corner-down-right": 61769,
  "corner-left-down": 61770,
  "corner-left-up": 61771,
  "corner-right-down": 61772,
  "corner-right-up": 61773,
  "corner-up-left": 61774,
  "corner-up-right": 61775,
  "cpu": 61776,
  "credit-card": 61777,
  "crop": 61778,
  "crosshair": 61779,
  "database": 61780,
  "delete": 61781,
  "disc": 61782,
  "divide": 61783,
  "divide-circle": 61784,
  "divide-square": 61785,
  "dollar-sign": 61786,
  "download": 61787,
  "download-cloud": 61788,
  "dribbble": 61789,
  "droplet": 61790,
  "edit": 61791,
  "edit-2": 61792,
  "edit-3": 61793,
  "external-link": 61794,
  "eye": 61795,
  "eye-off": 61796,
  "facebook": 61797,
  "fast-forward": 61798,
  "feather": 61799,
  "figma": 61800,
  "file": 61801,
  "file-minus": 61802,
  "file-plus": 61803,
  "file-text": 61804,
  "film": 61805,
  "filter": 61806,
  "flag": 61807,
  "folder": 61808,
  "folder-minus": 61809,
  "folder-plus": 61810,
  "framer": 61811,
  "frown": 61812,
  "gift": 61813,
  "git-branch": 61814,
  "git-commit": 61815,
  "git-merge": 61816,
  "git-pull-request": 61817,
  "github": 61818,
  "gitlab": 61819,
  "globe": 61820,
  "grid": 61821,
  "hard-drive": 61822,
  "hash": 61823,
  "headphones": 61824,
  "heart": 61825,
  "help-circle": 61826,
  "hexagon": 61827,
  "home": 61828,
  "image": 61829,
  "inbox": 61830,
  "info": 61831,
  "instagram": 61832,
  "italic": 61833,
  "key": 61834,
  "layers": 61835,
  "layout": 61836,
  "life-buoy": 61837,
  "link": 61838,
  "link-2": 61839,
  "linkedin": 61840,
  "list": 61841,
  "loader": 61842,
  "lock": 61843,
  "log-in": 61844,
  "log-out": 61845,
  "mail": 61846,
  "map": 61847,
  "map-pin": 61848,
  "maximize": 61849,
  "maximize-2": 61850,
  "meh": 61851,
  "menu": 61852,
  "message-circle": 61853,
  "message-square": 61854,
  "mic": 61855,
  "mic-off": 61856,
  "minimize": 61857,
  "minimize-2": 61858,
  "minus": 61859,
  "minus-circle": 61860,
  "minus-square": 61861,
  "monitor": 61862,
  "moon": 61863,
  "more-horizontal": 61864,
  "more-vertical": 61865,
  "mouse-pointer": 61866,
  "move": 61867,
  "music": 61868,
  "navigation": 61869,
  "navigation-2": 61870,
  "octagon": 61871,
  "package": 61872,
  "paperclip": 61873,
  "pause": 61874,
  "pause-circle": 61875,
  "pen-tool": 61876,
  "percent": 61877,
  "phone": 61878,
  "phone-call": 61879,
  "phone-forwarded": 61880,
  "phone-incoming": 61881,
  "phone-missed": 61882,
  "phone-off": 61883,
  "phone-outgoing": 61884,
  "pie-chart": 61885,
  "play": 61886,
  "play-circle": 61887,
  "plus": 61888,
  "plus-circle": 61889,
  "plus-square": 61890,
  "pocket": 61891,
  "power": 61892,
  "printer": 61893,
  "radio": 61894,
  "refresh-ccw": 61895,
  "refresh-cw": 61896,
  "repeat": 61897,
  "rewind": 61898,
  "rotate-ccw": 61899,
  "rotate-cw": 61900,
  "rss": 61901,
  "save": 61902,
  "scissors": 61903,
  "search": 61904,
  "send": 61905,
  "server": 61906,
  "settings": 61907,
  "share": 61908,
  "share-2": 61909,
  "shield": 61910,
  "shield-off": 61911,
  "shopping-bag": 61912,
  "shopping-cart": 61913,
  "shuffle": 61914,
  "sidebar": 61915,
  "skip-back": 61916,
  "skip-forward": 61917,
  "slack": 61918,
  "slash": 61919,
  "sliders": 61920,
  "smartphone": 61921,
  "smile": 61922,
  "speaker": 61923,
  "square": 61924,
  "star": 61925,
  "stop-circle": 61926,
  "sun": 61927,
  "sunrise": 61928,
  "sunset": 61929,
  "table": 61930,
  "tablet": 61931,
  "tag": 61932,
  "target": 61933,
  "terminal": 61934,
  "thermometer": 61935,
  "thumbs-down": 61936,
  "thumbs-up": 61937,
  "toggle-left": 61938,
  "toggle-right": 61939,
  "tool": 61940,
  "trash": 61941,
  "trash-2": 61942,
  "trello": 61943,
  "trending-down": 61944,
  "trending-up": 61945,
  "triangle": 61946,
  "truck": 61947,
  "tv": 61948,
  "twitch": 61949,
  "twitter": 61950,
  "type": 61951,
  "umbrella": 61952,
  "underline": 61953,
  "unlock": 61954,
  "upload": 61955,
  "upload-cloud": 61956,
  "user": 61957,
  "user-check": 61958,
  "user-minus": 61959,
  "user-plus": 61960,
  "user-x": 61961,
  "users": 61962,
  "video": 61963,
  "video-off": 61964,
  "voicemail": 61965,
  "volume": 61966,
  "volume-1": 61967,
  "volume-2": 61968,
  "volume-x": 61969,
  "watch": 61970,
  "wifi": 61971,
  "wifi-off": 61972,
  "wind": 61973,
  "x": 61974,
  "x-circle": 61975,
  "x-octagon": 61976,
  "x-square": 61977,
  "youtube": 61978,
  "zap": 61979,
  "zap-off": 61980,
  "zoom-in": 61981,
  "zoom-out": 61982
}